import { cloneDeep, isEqual } from 'lodash';
import { useEffect, useRef, useState } from 'react';

const useDirtyFormConfirmation = ({ formContext, isComplete, setComplete }) => {
  const { onClose, workingState } = formContext;

  const initialValue = useRef<any>();
  const [isConfirmCancelModalVisible, setConfirmCancelModalVisible] = useState(false);

  const isModified = initialValue.current && !isEqual(initialValue.current, workingState);

  useEffect(() => {
    if (!initialValue.current) {
      initialValue.current = cloneDeep(workingState);
    }
  }, [initialValue, workingState]);

  useEffect(() => {
    if (isComplete) {
      onClose();
    }
  }, [isComplete, onClose]);

  const handleStay = () => setConfirmCancelModalVisible(false);
  const handleCancel = () => (isModified ? setConfirmCancelModalVisible(true) : setComplete(true));

  return {
    handleCancel,
    handleStay,
    initialValue,
    isComplete,
    isConfirmCancelModalVisible,
    isModified,
  };
};

export default useDirtyFormConfirmation;
